var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Error object returned when `useFetch` encounters a response other than `ok` from a request.
 */
var HTTPError = /** @class */ (function (_super) {
    __extends(HTTPError, _super);
    function HTTPError(response) {
        var _this = this;
        var code = response.status || response.status === 0 ? response.status : '';
        var title = response.statusText || '';
        var status = "".concat(code, " ").concat(title).trim();
        var reason = status ? "status code ".concat(status) : 'an unknown error';
        _this = _super.call(this, "Request failed with ".concat(reason)) || this;
        _this.name = 'HTTPError';
        _this.response = response;
        return _this;
    }
    return HTTPError;
}(Error));
export default HTTPError;
//# sourceMappingURL=http-error.js.map